import head from "lodash/head";
import map from "lodash/map";
import React, { useCallback, useEffect } from "react";
import { NODE_GROUP_ID_ATTR, NODE_ID_ATTR, postBlockIdPrefix } from "../constants";
import Post from "./post";
import addSendToGraphListener from "./utils/listeners/addSendToGraphListener";
export default function SwitcherFeed({ nodeSources, documentObjects, onLoadNodeContent, documentId, masterNodeSource, sendToGraphSelector, onPhotoSendToGraph, onTextSendToGraph }) {
    const nodeSource = head(nodeSources);
    useEffect(() => {
        const sendToGraphElement = sendToGraphSelector
            ? document.querySelector(sendToGraphSelector)
            : undefined;
        return addSendToGraphListener(sendToGraphElement, postBlockIdPrefix, NODE_ID_ATTR, NODE_GROUP_ID_ATTR, documentId, documentObjects, onTextSendToGraph);
    }, [sendToGraphSelector, documentId, documentObjects, onTextSendToGraph]);
    const handleLoadContent = useCallback((nodeId, masterNodeId, completed, rejected) => {
        onLoadNodeContent &&
            documentId &&
            onLoadNodeContent(documentId, nodeId, masterNodeId, completed, rejected);
    }, [documentId, onLoadNodeContent]);
    if (!documentId) {
        return React.createElement("div", null);
    }
    if ((nodeSources === null || nodeSources === void 0 ? void 0 : nodeSources.length) === 1 && nodeSource) {
        return (React.createElement(Post, { isSingle: true, nodeSource: nodeSource, documentObjects: documentObjects, onLoadContent: handleLoadContent, masterNodeSource: masterNodeSource, documentId: documentId, onPhotoSendToGraph: onPhotoSendToGraph, onTextSendToGraph: onTextSendToGraph, blockIdPrefix: postBlockIdPrefix }));
    }
    return (React.createElement(React.Fragment, null, map(nodeSources, nodeSourceMulti => (React.createElement(Post, { className: "mb-1", key: nodeSourceMulti.NodeId, nodeSource: nodeSourceMulti, documentObjects: documentObjects, onLoadContent: handleLoadContent, masterNodeSource: masterNodeSource, documentId: documentId, onPhotoSendToGraph: onPhotoSendToGraph, onTextSendToGraph: onTextSendToGraph, blockIdPrefix: postBlockIdPrefix })))));
}
